"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ConfidenceNumberGauge_1 = __importDefault(require("./ConfidenceNumberGauge"));
exports.default = ConfidenceNumberGauge_1.default;
//# sourceMappingURL=index.js.map